import { ADD_METHODS } from '../helper';
import Heading from './Heading';

const Badge = ({ children, className = '' }) => (
  <span className={`shrink-0 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-amber-700 ${className}`}>
    {children}
  </span>
);

const Method = ({ onChoose }) => (
  <>
    <Heading
      title="How would you like to add it?"
      description="Pick whichever is easier — you can change it later."
    />

    <div className="space-y-3">
      {ADD_METHODS.map(({ flow, icon: Icon, title, description, badge = '' }) => (
        <button
          key={flow}
          type="button"
          onClick={() => onChoose(flow)}
          className="flex w-full items-center gap-4 rounded-xl border border-gray-200 p-4 text-left transition-colors hover:border-teamcare-blue hover:bg-blue-50/40"
        >
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-teamcare-blue">
            <Icon size={20} />
          </span>

          <span className="min-w-0 flex-1">
            <span className="flex flex-wrap items-center gap-x-2 gap-y-1">
              <span className="text-sm font-bold text-secondary-900">{title}</span>
              {badge && <Badge className="sm:hidden">{badge}</Badge>}
            </span>
            <span className="mt-0.5 block text-xs text-secondary-500">{description}</span>
          </span>

          {badge && <Badge className="hidden sm:inline-flex">{badge}</Badge>}
        </button>
      ))}
    </div>
  </>
);

export default Method;
